import { Table } from "flowbite-react";
import { formatToReal } from "../../../utils/utils";
import TitleStripe from "../TitleStripe";
import NoOcurrence from "./NoOcurrence";
import AvisoCard from "./AvisoCard";

const RestritivaPJ = ({ data }) => {
  return (
    <>
      <TitleStripe>Alerta de restrições II</TitleStripe>
      <div className="container-alerts five-columns">
        <AvisoCard
          title="Negativações"
          hasRestrictions={
            data?.Restrictive?.Negative?.Apontamentos?.Apontamento[0]
              ?.ApontamentoDetails?.ApontamentoDetail?.length > 0
          }
          messageError={`${data?.Restrictive?.Negative?.Apontamentos?.Apontamento[0]?.ApontamentoDetails?.ApontamentoDetail?.length} 
                        ocorrências`}
        />
        <AvisoCard
          title="Cheques sem fundo"
          hasRestrictions={
            data?.Restrictive?.Negative?.CCFApontamentos?.CCFApontamento[0]
              ?.CCFApontamentoDetails?.CCFApontamento?.length > 0
          }
          messageError={`${data?.Restrictive?.Negative?.CCFApontamentos?.CCFApontamento[0]?.CCFApontamentoDetails?.CCFApontamento?.length} 
                        ocorrências`}
        />
        <AvisoCard
          title="Ações judiciais"
          hasRestrictions={
            data?.Restrictive?.Negative?.LawSuitLevelsApontamentos
              ?.LawSuitLevelsApontamento[0]?.LawSuitDetails?.LawSuitDetail
              ?.length > 0
          }
          messageError={`${data?.Restrictive?.Negative?.LawSuitLevelsApontamentos?.LawSuitLevelsApontamento[0]?.LawSuitDetails?.LawSuitDetail?.length} 
                        ocorrências`}
        />
        <AvisoCard
          title="Ações judiciais de falência"
          hasRestrictions={
            data?.Restrictive?.Negative?.LawSuitBankruptApontamentos
              ?.LawSuitBankruptApontamento[0]?.LawSuitDetails?.LawSuitDetail
              ?.length > 0
          }
          messageError={`${data?.Restrictive?.Negative?.LawSuitBankruptApontamentos?.LawSuitBankruptApontamento[0]?.LawSuitDetails?.LawSuitDetail?.length} 
                        ocorrências`}
        />
        <AvisoCard
          title="Protestos"
          hasRestrictions={
            data?.Restrictive?.Protests?.Protest[0]?.Protests?.Conteudo
              ?.length > 0
          }
          messageError={`${data?.Restrictive?.Protests?.Protest[0]?.Protests?.Conteudo?.length} 
                        ocorrências`}
        />
      </div>
      <TitleStripe>Restritiva</TitleStripe>

      <div className="title-syncx mt-4">Negativações</div>
      {data?.Restrictive?.Negative?.Apontamentos?.Apontamento[0]
        ?.ApontamentoDetails?.ApontamentoDetail?.length > 0 ? (
        <div className="overflow-hidden rounded-md">
          <Table striped className="w-full">
            <Table.Head>
              <td className="bg-primary py-1 px-1 font-semibold text-2xs text-white">
                Empresa
              </td>
              <td className="bg-primary py-1 px-1 font-semibold text-2xs text-white text-center">
                Data
              </td>
              <td className="bg-primary py-1 px-1 text-center font-semibold text-2xs text-white">
                Contrato
              </td>
              <td className="bg-primary py-1 px-1 text-center font-semibold text-2xs text-white">
                Valor
              </td>
            </Table.Head>
            <Table.Body>
              {data?.Restrictive?.Negative?.Apontamentos?.Apontamento[0]?.ApontamentoDetails?.ApontamentoDetail?.map(
                (debit, index) => (
                  <tr
                    key={index}
                    className={`${
                      index % 2 === 0 ? "bg-white" : "bg-gray-100"
                    }`}
                  >
                    <td className="p-1">{debit.CompanyName}</td>
                    <td className="p-1">
                      {debit.DateIncluded.Day}/{debit.DateIncluded.Month}/
                      {debit.DateIncluded.Year}
                    </td>
                    <td className="p-1 text-center">{debit.ContractNumber}</td>
                    <td className="p-1 text-center">
                      {formatToReal(debit.Amount)}
                    </td>
                  </tr>
                )
              )}
            </Table.Body>
          </Table>
        </div>
      ) : (
        <NoOcurrence />
      )}

      <div className="title-syncx mt-4">Cheques sem fundo</div>
      {data?.Restrictive?.Negative?.CCFApontamentos?.CCFApontamento[0]
        ?.CCFApontamentoDetails?.CCFApontamento?.length > 0 ? (
        <div className="overflow-hidden rounded-md">
          <Table striped className="w-full">
            <Table.Head>
              <td className="bg-primary py-1 px-1 font-semibold text-2xs text-white">
                Banco
              </td>
              <td className="bg-primary py-1 px-1 text-center font-semibold text-2xs text-white">
                Documento
              </td>
              <td className="bg-primary py-1 px-1 text-center font-semibold text-2xs text-white">
                Motivo
              </td>
              <td className="bg-primary py-1 px-1 text-center font-semibold text-2xs text-white">
                Data
              </td>
            </Table.Head>
            <Table.Body>
              {data?.Restrictive?.Negative?.CCFApontamentos?.CCFApontamento[0]?.CCFApontamentoDetails?.CCFApontamento?.map(
                (debit, index) => (
                  <tr
                    key={index}
                    className={`${
                      index % 2 === 0 ? "bg-white" : "bg-gray-100"
                    }`}
                  >
                    <td className="p-1">{debit.ReportingNameBank}</td>
                    <td className="p-1 text-center">{debit.CpfCnpj}</td>
                    <td className="p-1 text-center">{debit.ReasonBounce}</td>
                    <td className="p-1 text-center">
                      {debit.DateLastBounce.Day}/{debit.DateLastBounce.Month}/
                      {debit.DateLastBounce.Year}
                    </td>
                  </tr>
                )
              )}
            </Table.Body>
          </Table>
        </div>
      ) : (
        <NoOcurrence />
      )}

      <div className="title-syncx mt-4">Ações Judiciais</div>
      {data?.Restrictive?.Negative?.LawSuitLevelsApontamentos
        ?.LawSuitLevelsApontamento[0]?.LawSuitDetails?.LawSuitDetail?.length >
      0 ? (
        <div className="overflow-hidden rounded-md">
          <Table striped className="w-full text-xs">
            <Table.Head>
              <td className="bg-primary py-1 px-1 font-semibold text-2xs text-white">
                Fórum
              </td>
              <td className="bg-primary py-1 px-1 font-semibold text-2xs text-white text-center">
                Data
              </td>
              <td className="bg-primary py-1 px-1 text-center font-semibold text-2xs text-white">
                Autor
              </td>
              <td className="bg-primary py-1 px-1 text-center font-semibold text-2xs text-white">
                Tipo
              </td>
              <td className="bg-primary py-1 px-1 text-center font-semibold text-2xs text-white">
                Cidade
              </td>
              <td className="bg-primary py-1 px-1 text-center font-semibold text-2xs text-white text-center">
                Valor
              </td>
            </Table.Head>
            <Table.Body>
              {data?.Restrictive?.Negative?.LawSuitLevelsApontamentos?.LawSuitLevelsApontamento[0]?.LawSuitDetails?.LawSuitDetail?.map(
                (debit, index) => (
                  <tr
                    key={index}
                    className={`${
                      index % 2 === 0 ? "bg-white" : "bg-gray-100"
                    }`}
                  >
                    <td className="p-1">{debit.Forum}</td>
                    <td className="p-1 text-center">
                      {debit.DateDistribution.Day}/
                      {debit.DateDistribution.Month}/
                      {debit.DateDistribution.Year}
                    </td>
                    <td className="p-1 text-center">{debit.ProcessAuthor}</td>
                    <td className="p-1 text-center">{debit.ProcessType}</td>
                    <td className="p-1 text-center">{debit.City}</td>
                    <td className="p-1 text-center">
                      {formatToReal(debit.AmountLawsuit) || 0}
                    </td>
                  </tr>
                )
              )}
            </Table.Body>
          </Table>
        </div>
      ) : (
        <NoOcurrence />
      )}

      <div className="title-syncx mt-4">Ações Judiciais de Falência</div>
      {data?.Restrictive?.Negative?.LawSuitBankruptApontamentos
        ?.LawSuitBankruptApontamento[0]?.LawSuitDetails?.LawSuitDetail?.length >
      0 ? (
        <div className="overflow-hidden rounded-md">
          <Table striped className="w-full text-xs">
            <Table.Head>
              <td className="bg-primary py-1 px-1 font-semibold text-2xs text-white">
                Fórum
              </td>
              <td className="bg-primary py-1 px-1 font-semibold text-2xs text-white text-center">
                Data
              </td>
              <td className="bg-primary py-1 px-1 text-center font-semibold text-2xs text-white">
                Autor
              </td>
              <td className="bg-primary py-1 px-1 text-center font-semibold text-2xs text-white">
                Tipo
              </td>
              <td className="bg-primary py-1 px-1 text-center font-semibold text-2xs text-white">
                Cidade
              </td>
              <td className="bg-primary py-1 px-1 text-center font-semibold text-2xs text-white text-center">
                Valor
              </td>
            </Table.Head>
            <Table.Body>
              {data?.Restrictive?.Negative?.LawSuitBankruptApontamentos?.LawSuitBankruptApontamento[0]?.LawSuitDetails?.LawSuitDetail?.map(
                (debit, index) => (
                  <tr
                    key={index}
                    className={`${
                      index % 2 === 0 ? "bg-white" : "bg-gray-100"
                    }`}
                  >
                    <td className="p-1">{debit.Forum}</td>
                    <td className="p-1 text-center">
                      {debit.DateDistribution.Day}/
                      {debit.DateDistribution.Month}/
                      {debit.DateDistribution.Year}
                    </td>
                    <td className="p-1 text-center">{debit.ProcessAuthor}</td>
                    <td className="p-1 text-center">{debit.ProcessType}</td>
                    <td className="p-1 text-center">{debit.City}</td>
                    <td className="p-1 text-center">
                      {formatToReal(debit.AmountLawsuit) || 0}
                    </td>
                  </tr>
                )
              )}
            </Table.Body>
          </Table>
        </div>
      ) : (
        <NoOcurrence />
      )}

      <div className="title-syncx mt-4">Protestos</div>
      {data?.Restrictive?.Protests?.Protest[0]?.Protests?.Conteudo?.length >
      0 ? (
        <div className="overflow-hidden rounded-md">
          <Table striped className="w-full text-xs">
            <Table.Head>
              <td className="bg-primary py-1 px-1 font-semibold text-2xs text-white">
                Cartório
              </td>
              <td className="bg-primary py-1 px-1 font-semibold text-2xs text-white text-center">
                Quantidade
              </td>
              <td className="bg-primary py-1 px-1 text-center font-semibold text-2xs text-white">
                Cidade
              </td>
              <td className="bg-primary py-1 px-1 text-center font-semibold text-2xs text-white text-center">
                Valor
              </td>
            </Table.Head>
            <Table.Body>
              {data?.Restrictive?.Protests?.Protest[0]?.Protests?.Conteudo?.map(
                (protest, index) => (
                  <tr
                    key={index}
                    className={`${
                      index % 2 === 0 ? "bg-white" : "bg-gray-100"
                    }`}
                  >
                    <td className="p-1">{protest.nome}</td>
                    <td className="p-1 text-center">{protest.protestos}</td>
                    <td className="p-1 text-center">{protest.cidade}</td>
                    <td className="p-1 text-center">
                      {formatToReal(protest.valor_protestado) || 0}
                    </td>
                  </tr>
                )
              )}
            </Table.Body>
          </Table>
        </div>
      ) : (
        <NoOcurrence />
      )}

      <div className="title-syncx mt-4">
        Histórico de consultas nos últimos 12 meses
      </div>
      {data?.Restrictive?.Inquiries?.InquiryDetails?.InquiryDetail?.length >
      0 ? (
        <div className="overflow-hidden rounded-md">
          <Table striped className="w-full text-xs">
            <Table.Head>
              <td className="bg-primary py-1 px-1 font-semibold text-2xs text-white">
                Empresa
              </td>
              <td className="bg-primary py-1 px-1 font-semibold text-2xs text-white text-center">
                Documento
              </td>
              <td className="bg-primary py-1 px-1 text-center font-semibold text-2xs text-white">
                Atividade
              </td>
              <td className="bg-primary py-1 px-1 text-center font-semibold text-2xs text-white">
                Data
              </td>
            </Table.Head>
            <Table.Body>
              {data?.Restrictive?.Inquiries?.InquiryDetails.InquiryDetail?.map(
                (inquiry, index) => (
                  <tr
                    key={index}
                    className={`${
                      index % 2 === 0 ? "bg-white" : "bg-gray-100"
                    }`}
                  >
                    <td className="p-1">{inquiry.SourceName}</td>
                    <td className="p-1 text-center">{inquiry.SourceCnpj}</td>
                    <td className="p-1 text-center">
                      {inquiry.SourceActivity}
                    </td>
                    <td className="p-1 text-center">
                      {inquiry.DateInquiry.Month}/{inquiry.DateInquiry.Year}
                    </td>
                  </tr>
                )
              )}
            </Table.Body>
          </Table>
        </div>
      ) : (
        <NoOcurrence />
      )}
    </>
  );
};

export default RestritivaPJ;
